import axios from 'axios';
import baseService from '../shared/baseService';

const storageKeywordSearchService = (clientId: number) =>
    baseService(`clients/${clientId}/storage-keywords`);

const getNewsByKeyword = (clientId: number, keyword: string, initialDate: Date, finalDate: Date) =>
    axios.get(`clients/${clientId}/storage-keywords?keyword=${keyword}&initialDate=${initialDate.toISOString()}&finalDate=${finalDate.toISOString()}`);

export default {
    getNewsByKeyword,
    storageKeywordSearchService
};
